import OptOutDefault from "../../../../contents/docs/product-analytics/_snippets/multilanguage/opt-out-default.mdx";
import OptOutPerPerson from "../../../../contents/docs/product-analytics/_snippets/multilanguage/opt-out-per-person.mdx";
import OptIn from "../../../../contents/docs/product-analytics/_snippets/multilanguage/opt-in.mdx";
import CheckOptOut from "../../../../contents/docs/product-analytics/_snippets/multilanguage/check-opt-out.mdx";
import * as React from 'react';
export default {
  OptOutDefault,
  OptOutPerPerson,
  OptIn,
  CheckOptOut,
  React
};